@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  <div class="nav-container mat-toolbar-row-padding flex flex-between-center w-full h-full">
    <div>
      <button
        [ngClass]="{ 'small-button': breakpoints.ltMd }"
        [queryParams]="queryParams || null"
        class="max-md:hidden"
        color="primary"
        mat-button
        routerLink="/"
      >
        Go to home
      </button>
      <button
        [ngClass]="{ 'small-button': breakpoints.ltMd }"
        [queryParams]="queryParams || null"
        class="md:hidden"
        color="primary"
        mat-icon-button
        routerLink="/"
      >
        <mat-icon color="primary" svgIcon="arrow_back"></mat-icon>
      </button>
    </div>
  </div>
}
